var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatistics = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1435_4863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 14.0508H11.7187C12.0937 14.0508 12.4062 13.7383 12.4062 13.3633C12.4062 12.9883 12.0937 12.6758 11.7187 12.6758H8.34375C7.96875 12.6758 7.65625 12.9883 7.65625 13.3633C7.65625 13.7383 7.96875 14.0508 8.34375 14.0508Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 15.332H8.34375C7.96875 15.332 7.65625 15.6445 7.65625 16.0195C7.65625 16.3945 7.96875 16.707 8.34375 16.707H14.125C14.5 16.707 14.8125 16.3945 14.8125 16.0195C14.8125 15.6445 14.5312 15.332 14.125 15.332Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7813 0.644531H6.28125C5.34375 0.644531 4.59375 1.39453 4.59375 2.33203V13.8008H1.96875C1.59375 13.8008 1.28125 14.1133 1.28125 14.4883V17.582C1.28125 18.6445 2.15625 19.5195 3.21875 19.5195H16.7813C17.875 19.5195 18.75 18.6445 18.75 17.5508V2.58203C18.75 1.51953 17.8438 0.644531 16.7813 0.644531ZM3.1875 18.1445C2.90625 18.1445 2.65625 17.8945 2.65625 17.6133V15.207H4.59375V17.582C4.59375 17.8633 4.34375 18.1133 4.0625 18.1133H3.1875V18.1445ZM17.3438 17.582C17.3438 17.8945 17.0938 18.1445 16.7813 18.1445H5.9375C6 17.9883 6 17.8008 6 17.6133V2.33203C6 2.17578 6.125 2.05078 6.28125 2.05078H16.75C17.0625 2.05078 17.3125 2.30078 17.3125 2.61328V17.582H17.3438Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 6.39453L13.0938 7.11328L11.0625 6.14453C10.875 6.05078 10.6562 6.05078 10.4688 6.14453L9.0625 6.73828V4.51953C9.0625 4.14453 8.75 3.83203 8.375 3.83203C8 3.83203 7.6875 4.14453 7.6875 4.51953V10.7695C7.6875 11.1445 8 11.457 8.375 11.457H14.5938C14.9688 11.457 15.2813 11.1445 15.2813 10.7695C15.2813 10.3945 14.9688 10.082 14.5938 10.082H9.0625V8.30078L10.7812 7.51953L12.8125 8.48828C12.9062 8.55078 13 8.55078 13.125 8.55078C13.2188 8.55078 13.3125 8.51953 13.4063 8.48828L15.2188 7.64453C15.5625 7.48828 15.7188 7.05078 15.5625 6.70703C15.4062 6.36328 14.9687 6.20703 14.625 6.39453Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1435_4863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.0820312)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatistics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/statistics.5db17b04e1830996d9815f83cf556ee8.svg";